
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiEngine as ObiEngineElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-engine.js';
 
 
 

 
 export const ObiEngine = createComponent({
   react: React,
   tagName: 'obi-engine',
   elementClass: ObiEngineElement,
   events: {
     
   }
  });
 
 